import request from '@/utils/request'

// 首页统计
export const statistics = () => {
  return request({
    url: '/admin-api/client/pc/home/overview-statistics',
    method: 'get',
  })
}

// 获取租户号
export const tenantNumber = (name)=>{
  return request({
    url: `/admin-api/system/tenant/get-id-by-name?name=${name}`,
    method: 'get',
  })
}
